import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import BuildIcon from '@mui/icons-material/Build';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import GroupsIcon from '@mui/icons-material/Groups';
import LocalActivity from '@mui/icons-material/LocalActivity';

import {
  Alert,
  Avatar,
  Button as Btn,
  Chip,
  DialogActions,
  Divider,
  Grid,
  ListSubheader,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  Button,
  DataGrid,
  DateAndTimePicker,
  Dt,
  Editor,
  Fab,
  IconButton,
  Page,
  Select,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SearchBox } from '../../../components/v2/SearchBox';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';

import { KnowledgeCourse } from '../../../models/KnowledgeCourse';
import { KnowledgeSubscription } from '../../../models/KnowledgeSubscription';
import Visibility from '@mui/icons-material/Visibility';
import { Practice } from '../../../models/Practice';
import { User } from '../../../models/User';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import { Base } from '../../../components/v2/dialogs/Base';
import Person from '@mui/icons-material/Person';
import Settings from '@mui/icons-material/Settings';
import Delete from '@mui/icons-material/Delete';
import Schedule from '@mui/icons-material/Schedule';

import HelpersLanguage from '../../../actions/helpers/language';

const { DateTime } = require("luxon");

type Props = {}

export const CoachKnowledgeCourseSubs: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();

  
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("is_approved ASC, approved_at DESC, is_approved DESC");
  const [search, setSearch] = useState<string>("");
  const [clientSearch, setClientSearch] = useState<string>("");
  const [newSub, setNewSub] = useState<number>();
  const [message, setMessage] = useState<string>("");
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [activeDialog, setActiveDialog] = useState<KnowledgeSubscription>();
  const [approvalMessage, setApprovalMessage] = useState<string>("");
  const [newEnds, setNewEnds] = useState<string>();
  const [showProgress, setShowProgress] = useState<KnowledgeSubscription>();

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["knowledge_course", (login?.practice_id || currentPractice?.id), objectId],
    queryFn: () =>
      fetch_one<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          id: objectId,
          fields: [
            'id', 'name', 'mollie_data'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    // select: (d) => {
    //   return {
    //     ...d,
    //     birth_date: DateTime.fromISO(d.birth_date).toFormat("dd/LL/y")
    //   };
    // },
    enabled: !!(login?.practice_id || currentPractice?.id) && parseInt(objectId || '', 10) > 0,
  });

  const {
    data: selectedUser,
    // isLoading: objectLoading,
    // isError: objectError,
    isSuccess: selectedUserSuccess,
    // refetch: objectRefetch,
  } = useQuery({
    queryKey: ["selected_user", newSub],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          id: newSub,
          fields: [
            'id', 'first_name', 'last_name', 'email', 'practice|id/name', 'type'
          ],
          practice_id: (login?.practice_id || currentPractice?.id)
        },
        login
      ),
    enabled: !!newSub,
  });

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["coach", "knowledge_subs", (login?.practice_id || currentPractice?.id), {page: page, order: order, search: search}],
    queryFn: () =>
      fetch_all_with_count<KnowledgeSubscription>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_subscription',
          fields: ['id', 'user', 'created_at', 'finished_at', 'ends_at', 'is_approved', 'approved_at', 'progress', 'mollie_link', 'mollie_data'],
          sub_fields: {
            user: ['id', 'first_name', 'last_name', 'email', 'type'],
            mollie_link: ['id', 'paid', 'paid_at']
          },
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              knowledge_course_id: object?.id
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id) && !!object?.id,
  });

  const {
    data: clients,
    isLoading: clientsLoading,
    isError: clientsError,
    isSuccess: clientsSuccess,
    // refetch: clientsRefetch,
  } = useQuery({
    queryKey: ["clients", 'with_email', currentPractice?.id, clientSearch],
    queryFn: () =>
      fetch_all<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'user',
          fields: ['id', 'full_name', 'last_login_date', 'language_id', 'email', 'first_name', 'last_name'],
          order: "first_name ASC, last_name ASC",
          filter: {
            search: clientSearch,
            advanced: {
              for_practice: (login?.practice_id || currentPractice?.id),
              // enabled: '1'
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });
  const {
    data: coaches,
    isLoading: coachesLoading,
    isError: coachesError,
    isSuccess: coachesSuccess,
    // refetch: coachesRefetch,
  } = useQuery({
    queryKey: ["coaches", 'with_email', currentPractice?.id, clientSearch],
    queryFn: () =>
      fetch_all<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'coach',
          fields: ['id', 'full_name', 'email', 'get_item_thumb', 'first_name', 'last_name'],
          filter: {
            search: clientSearch,
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id),
              enabled: '1'
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });
  const {
    data: practices,
    isLoading: practicesLoading,
    isError: practicesError,
    isSuccess: practicesSuccess,
    // refetch: coachesRefetch,
  } = useQuery({
    queryKey: ["practices", 'coaches_with_email', currentPractice?.id, clientSearch],
    queryFn: () =>
      fetch_all<Practice>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'practice',
          fields: ['id', 'name', 'coaches|active|not_secretary'],
          sub_fields: {
            'coaches_active_not_secretary': ['id', 'full_name', 'email', 'get_item_thumb', 'first_name', 'last_name']
          },
          filter: {
            search: clientSearch,
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id),
              enabled: '1',
            }
          }
        },
        login
      ),
    enabled: !!currentPractice?.id
  });









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{custom_result: {success?: boolean;}}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setNewSub(undefined);
      setMessage("");
      setApprovalMessage("");
      setDialogOpen(false);
      setNewEnds(undefined);
      objectsRefetch();
    },
  });
  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<KnowledgeSubscription>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setDestroyedOpen(true);
      objectsRefetch();
    },
  });








  const selectContentWithId = (field?:{[z:string]: string}, extraFallback?:string) => {
    let correct = (field || {})[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')];
    if (!!correct) return correct;
    let fallback = (field || {})['nl'];
    if (!!fallback) return fallback;
    let anyFallback = Object.values(field || {}).filter(fff => !!fff)[0];
    if (!!anyFallback) return anyFallback;
    if (!!extraFallback) return extraFallback;
    return t("general.translation_fallbacks.no_translation_available")
  }

  const columns: GridColDef[] = object?.mollie_data?.immediate_payment?.toString() === '1' ? [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'name', headerName: t("coach.models.knowledge_subscriptions.client_name"), width: 250, renderCell: params => <>
      <Typography variant="caption">{params.row.name}{params.row.user.type === "User::Coach" && <Chip label="Coach" sx={{marginLeft: 1}} size='small' color="default" />}</Typography>
    </> },
    { field: 'approval', headerName: t("coach.models.knowledge_subscriptions.approval"), width: 250, renderCell: params => <>
      {!!params.row.is_approved && <Check sx={{marginRight: 1, color: theme.palette.primary.main, marginBottom: -1}} />}
      {!params.row.is_approved && !!params.row.approved_at && <Close sx={{marginRight: 1, color: theme.palette.secondary.main, marginBottom: -1}} />}
      {!params.row.is_approved && !params.row.approved_at && <Typography variant="caption" sx={{fontStyle: 'italic'}}>Approval pending ...</Typography>}
      {!!params.row.is_approved && <Dt d={params.row.approved_at} f="ccc DD t" />}
    </>  },
    { field: 'created_at', headerName: t('coach.models.knowledge_subscriptions.created_at'), width: 200, renderCell: params => <>
      {!!params.row.created_at && <Dt d={params.row.created_at} f="ccc DD t" />}
    </> },
    { field: 'paid', headerName: t('coach.models.knowledge_subscriptions.paid'), width: 200, renderCell: params => <>
      {!!params.row?.mollie_data?.paid_at && <Dt d={params.row.mollie_data?.paid_at} f="ccc DD t" />}
      {!!params.row?.mollie_link?.paid && !!params.row?.mollie_link?.paid_at && <Dt d={params.row.mollie_link.paid_at} f="ccc DD t" />}
      {!params.row?.mollie_link?.paid && !params.row?.mollie_link?.paid_at && !params.row?.mollie_data?.paid_at && <Typography sx={{lineHeight: '48px', fontSize: '0.9rem', color: 'red'}}>{t("general.terms.unpaid")}</Typography>}
      {!!params.row?.mollie_data?.coupon && <Tooltip title={params.row?.mollie_data?.coupon}><LocalActivity sx={{marginLeft: 1, marginBottom: -0.5}} color="primary" /></Tooltip>}
    </> },
    { field: 'finished_at', headerName: t('coach.models.knowledge_subscriptions.finished_at'), width: 200, renderCell: params => <>
      {!!params.row.finished_at && <Dt d={params.row.finished_at} f="ccc DD t" />}
    </> },
    { field: 'ends_at', headerName: t('coach.models.knowledge_subscriptions.ends_at'), width: 200, renderCell: params => <>
      {!!params.row.ends_at && <Dt d={params.row.ends_at} f="ccc DD t" />}
      {!params.row.ends_at && !!params.row.is_approved &&  <Typography variant="caption" sx={{fontStyle: 'italic'}}>unlimited</Typography>}
    </> },
    { field: 'progress', headerName: t('coach.models.knowledge_subscriptions.progress'), width: 120, renderCell: params => <>
      {!!params.row.progress?.lessons && <Visibility sx={{marginRight: 1, color: theme.palette.primary.main, marginBottom: -1, cursor: 'pointer'}} onClick={() => {
        setShowProgress(params.row);
      }} />}
      <Typography variant="caption" sx={{fontStyle: 'italic'}}>{params.row.progress?.lessons}</Typography>
    </> },
  ] : [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'name', headerName: t("coach.models.knowledge_subscriptions.client_name"), width: 250, renderCell: params => <>
      <Typography variant="caption">{params.row.name}{params.row.user.type === "User::Coach" && <Chip label="Coach" sx={{marginLeft: 1}} size='small' color="default" />}</Typography>
    </> },
    { field: 'approval', headerName: t("coach.models.knowledge_subscriptions.approval"), width: 250, renderCell: params => <>
      {!!params.row.is_approved && <Check sx={{marginRight: 1, color: theme.palette.primary.main, marginBottom: -1}} />}
      {!params.row.is_approved && !!params.row.approved_at && <Close sx={{marginRight: 1, color: theme.palette.secondary.main, marginBottom: -1}} />}
      {!params.row.is_approved && !params.row.approved_at && <Typography variant="caption" sx={{fontStyle: 'italic'}}>Approval pending ...</Typography>}
      {!!params.row.is_approved && <Dt d={params.row.approved_at} f="ccc DD t" />}
    </>  },
    { field: 'created_at', headerName: t('coach.models.knowledge_subscriptions.created_at'), width: 200, renderCell: params => <>
      {!!params.row.created_at && <Dt d={params.row.created_at} f="ccc DD t" />}
    </> },
    { field: 'finished_at', headerName: t('coach.models.knowledge_subscriptions.finished_at'), width: 200, renderCell: params => <>
      {!!params.row.finished_at && <Dt d={params.row.finished_at} f="ccc DD t" />}
    </> },
    { field: 'ends_at', headerName: t('coach.models.knowledge_subscriptions.ends_at'), width: 200, renderCell: params => <>
      {!!params.row.ends_at && <Dt d={params.row.ends_at} f="ccc DD t" />}
      {!params.row.ends_at && !!params.row.is_approved &&  <Typography variant="caption" sx={{fontStyle: 'italic'}}>unlimited</Typography>}
    </> },
    { field: 'progress', headerName: t('coach.models.knowledge_subscriptions.progress'), width: 120, renderCell: params => <>
      {!!params.row.progress?.lessons && <Visibility sx={{marginRight: 1, color: theme.palette.primary.main, marginBottom: -1, cursor: 'pointer'}} onClick={() => {
        setShowProgress(params.row);
      }} />}
      <Typography variant="caption" sx={{fontStyle: 'italic'}}>{params.row.progress?.lessons}</Typography>
    </> },
  ];

  let results = [];
  results.push(<MenuItem value="">------</MenuItem>);
  results.push(<ListSubheader sx={{color: 'lightgrey'}}>{login?.practice_name}</ListSubheader>);
  (coaches || []).forEach(coach => {
    results.push(<MenuItem value={coach.id}>{coach.full_name} <span style={{color: 'rgba(0, 0, 0, 0.5)', marginLeft: 8, fontSize: '0.9rem'}}>({coach.email})</span></MenuItem>);
  });
  if ((coaches || []).length < 1) {
    results.push(<MenuItem disabled value="no_res">--- Geen resultaten ---</MenuItem>);
  }
  results.push(<ListSubheader sx={{color: 'lightgrey'}}>{t("coach.menu.users")}</ListSubheader>);
  (clients || []).forEach(client => {
    results.push(<MenuItem value={client.id}>{client.full_name} <span style={{color: 'rgba(0, 0, 0, 0.5)', marginLeft: 8, fontSize: '0.9rem'}}>({client.email})</span></MenuItem>);
  });
  if ((clients || []).length < 1) {
    results.push(<MenuItem disabled value="no_res">--- Geen resultaten ---</MenuItem>);
  }
  if (!!clientSearch && clientSearch.length > 2) {
    (practices || []).forEach(practice => {
      if ((practice.coaches_active_not_secretary || []).length > 0) {
        results.push(<ListSubheader sx={{color: 'lightgrey'}}>{practice.name}</ListSubheader>);
        (practice.coaches_active_not_secretary || []).forEach(coach => {
          results.push(<MenuItem value={coach.id}>{coach.full_name} <span style={{color: 'rgba(0, 0, 0, 0.5)', marginLeft: 8, fontSize: '0.9rem'}}>({coach.email})</span></MenuItem>);
        });
      }
    });
  }

  useEffect(() => {
    // console.log(!!selectedUser?.id, selectedUser);
    // if (!!selectedUser?.id) {
      // setFlickerEditor(true);
      setMessage(`<p>Beste ${selectedUser?.first_name || ""},</p><p>Hierbij nodig ik je uit voor de e-learning '${object?.name}'. Je kan deze terugvinden onder Kennisomgeving/Kennis delen.</p><p>Mvg, ${login?.first_name}</p>`);
      // setTimeout(() => {setFlickerEditor(false);}, 200);
    // }
  }, [selectedUser, selectedUserSuccess, object]);
  

  return <Page title={object?.name}
    titleCrumbs={[
      {
        title: t("coach.menu.knowledge_courses"),
        path: "/knowledge_courses"
      }
    ]}
  >
    {/* <SearchBox
      search={search}
      setSearch={setSearch}
      objectCount={count}
    /> */}

  <Grid container spacing={0}>
    <Grid item xs={12} md={6}>
      <TextInput
        id="client_search"
        caption={t("coach.models.knowledge_subscriptions.search_sub")}
        value={clientSearch}
        backend
        onChange={(e) => {
          setClientSearch(e);
        }}
      />
    </Grid>
    {coachesSuccess && clientsSuccess && <Grid item xs={12} md={6}>
      <Select
        fullWidth
        caption={t("coach.models.knowledge_subscriptions.new_sub")}
        displayEmpty
        backend
        id="recipient"
        value={newSub?.toString() || ''}
        setValue={(v) => {
          let id = v.toString() === '' ? undefined : parseInt(v.toString(), 10);
          setNewSub(id);
        }}
      >
        {results}
      </Select>
    </Grid>}
    {!!newSub && !!selectedUser && <Grid item xs={12}>
      {!flickerEditor && <Editor
        simple
        label={t("coach.models.knowledge_subscriptions.message")}
        value={message || ""}
        onChange={(e) => {
          setMessage(e);
        }}
      />}
    </Grid>}
    {!!newSub && !!selectedUser && <Grid item xs={12} sx={{marginBottom: 4}}>
      <Button
        label={t("coach.models.knowledge_subscriptions.invite_name", {name: selectedUser?.first_name})}
        id='invite_name'
        disabled={mutationCustomAction.isPending}
        contained
        onClick={(v) => {
          mutationCustomAction.mutate({
            formData: {
              object: 'knowledge_course',
              class_action: 'custom_api_subscribe',
              id: objectId,
              user_id: selectedUser?.id,
              message: message,
              as_coach: 1
            }
          });
        }}
        sx={{width: '100%', marginTop: 1}}
      />
    </Grid>}
  </Grid>




    <DataGrid
      action_count={2}
      hideCount
      actions={(params) => {
        return (<>
          <IconButton title="View" color="default" onClick={() => {
            setDialogOpen(true);
            setActiveDialog(params.row);
          }}>
            <Settings />
          </IconButton>
          <IconButton title="Client" color="default" onClick={() => {
            navigate(`/user/${params.row.user?.id}/detail`);
          }}>
            <Person />
          </IconButton>
        </>);
      }}
      objectCount={count}
      getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
      objects={(objects || []).map(u => ({
        ...u,
        name: [u.user?.first_name, u.user?.last_name].join(" ")
      }))}
      columns={columns}
      loader={objectsLoading}
      onSortModelChange={(a, b) => {
        let a_0_field:string = a[0].field;
        if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
        setOrder([a_0_field, a[0].sort].join(' '));
      }}
      page={page}
      setPage={(p) => {setPage(p);}}
    />

    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />

    <Base
      name="approval_flow"
      hidden={!dialogOpen}
      title={t("coach.dialogs.knowledge_approval_and_settings.title")}
      content={<Grid container spacing={1}>
        {!!activeDialog?.approved_at && <>
          {/* nieuw einde instellen, newEnds */}
          <Grid item xs={12}>
            <Typography sx={{
              fontSize: '0.7rem'
            }}>{t("coach.models.knowledge_subscriptions.new_end_time")} *</Typography>
            <DateAndTimePicker
              disableFuture={false}
              disablePast
              id="new_end_time"
              value={newEnds || (!!activeDialog.ends_at ? DateTime.fromISO(activeDialog.ends_at).toFormat("dd/LL/y t") : undefined) || DateTime.now().plus({years: 1}).toFormat("dd/LL/y t")}
              setValue={(e) => {
                setNewEnds(e);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              label={t("coach.models.knowledge_subscriptions.change_ends_at")}
              id='change_ends_at'
              disabled={mutationCustomAction.isPending}
              contained
              startIcon={<Schedule />}
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    class_action: 'custom_api_change_ends_at',
                    id: activeDialog?.id,
                    new_ends_at: DateTime.fromFormat(newEnds, "dd/LL/y t").toUTC().toFormat("dd/LL/y t")
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
        </>}
        {!!activeDialog?.approved_at && <>
          <Grid item xs={12}>
            <Divider />
            <Button
              label={t("coach.models.knowledge_subscriptions.delete_subscription")}
              id='delete_subscription'
              disabled={mutationCustomAction.isPending}
              contained
              secondary
              startIcon={<Delete />}
              onClick={(v) => {
                mutationDestroy.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    id: activeDialog?.id,
                    ob: {
                      id: activeDialog?.id,
                    }
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
        </>}


        {!activeDialog?.approved_at && <>
          {object?.mollie_data?.immediate_payment?.toString() === '1'  && <Grid item xs={12}>
            <Alert severity='info'>
              <Typography>{t("coach.models.knowledge_subscriptions.warning.approve_after_payment")}</Typography>
            </Alert>
          </Grid>}
          <Grid item xs={12}>
            {!flickerEditor && <Editor
              simple
              label={t("coach.models.knowledge_subscription_approval.message")}
              value={approvalMessage || ""}
              onChange={(e) => {
                setApprovalMessage(e);
              }}
            />}
          </Grid>
          <Grid item xs={6}>
            <Button
              label={t("coach.models.knowledge_subscriptions.do_approve")}
              id='do_approve'
              disabled={mutationCustomAction.isPending}
              contained
              startIcon={<Check />}
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    class_action: 'custom_api_do_approve',
                    id: activeDialog?.id,
                    approve: 1,
                    message: approvalMessage,
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
          <Grid item xs={6}>
            <Button
              label={t("coach.models.knowledge_subscriptions.do_disapprove")}
              id='do_disapprove'
              disabled={mutationCustomAction.isPending}
              contained
              secondary
              startIcon={<Close />}
              onClick={(v) => {
                mutationCustomAction.mutate({
                  formData: {
                    object: 'knowledge_subscription',
                    class_action: 'custom_api_do_approve',
                    id: activeDialog?.id,
                    disapprove: 1,
                    message: approvalMessage,
                  }
                });
              }}
              sx={{width: '100%', marginTop: 1}}
            />
          </Grid>
        </>}
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setDialogOpen(false);}}>{t("coach.general.actions.cancel")}</Btn>
      </DialogActions>}
      open={dialogOpen}
      setOpen={setDialogOpen}
    />

    <Base
      name="progress"
      hidden={!showProgress}
      title={t("coach.dialogs.knowledge_progress.title")}
      content={<Grid container spacing={1}>
        {(showProgress?.progress?.progress || []).map((line:any) => <Grid item xs={12}>
          <Typography sx={{
            paddingLeft: line[0],
            borderLeft: `${8 * line[0]}px solid transparent`,
            borderColor: theme.palette.primary.main,
            ...(!line[2] && line[0] > 0 ? {
              color: 'lightgrey'
            } : {})
          }}>{selectContentWithId(line[1] || {})}</Typography>
        </Grid>)}
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setShowProgress(undefined);}}>{t("coach.general.actions.cancel")}</Btn>
      </DialogActions>}
      open={!!showProgress}
      setOpen={(b) => {
        setShowProgress(!!b ? showProgress : undefined);
      }}
    />
  </Page>;
}
